import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiUrl } from './config';
import './BookingPage.css';
import './App.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Success = () => {
  const query = useQuery();
  const sessionId = query.get('session_id') || query.get('sessionId') || query.get('session');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sessionId) return setError('Missing session_id in URL');
    const fetchSession = async () => {
      try {
        const res = await fetch(`${apiUrl('/checkout-session')}?sessionId=${encodeURIComponent(sessionId)}`);
        if (!res.ok) throw new Error('Failed to fetch session');
        const json = await res.json();
        setData(json);
        // After payment, trigger calendar and email update if bookingId is present
        const paymentId = json?.session?.payment_intent?.id;
        if (paymentId) {
          await fetch(apiUrl('/api/booking/success'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              payment_id: paymentId, // from Stripe payload
              email: json?.session?.customer_details?.email, // from booking/session
              payment_amount: json?.session?.payment_intent?.amount, // from Stripe payload
              booking_id: json?.session?.metadata?.bookingId || '',
              stripe_session_id: json?.session?.id || ''
            })
          });
        }
      } catch (err) {
        setError(err.message || String(err));
      }
    };
    fetchSession();
  }, [sessionId]);

  return (
    <div className="App">
      <div className="banner">
        <h1>Thank you for the booking!</h1>
      </div>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <div className="booking-form" style={{maxWidth: 900}}>
          {error && <div style={{color: 'crimson'}}>Error: {error}</div>}
          {!error && !data && <div>Loading...</div>}
          {!error && data && (
            <div>
              <p style={{marginBottom: '0.5rem', textAlign: 'center', fontSize: '1.25rem', fontWeight: 700}}>Payment details:</p>
              <div style={{
                background: '#ffffff',
                padding: '1rem',
                borderRadius: 8,
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                marginBottom: '1rem',
              }}>
                <table style={{width: '100%', borderCollapse: 'collapse', textAlign: 'center'}}>
                  <tbody>
                    <tr>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem', fontWeight: 700}}>Payment ID:</td>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem'}}>{data?.session?.payment_intent?.id || 'N/A'}</td>
                    </tr>
                    <tr>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem', fontWeight: 700}}>Amount:</td>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem'}}>{typeof data?.session?.payment_intent?.amount === 'number' ? `$${(data.session.payment_intent.amount / 100).toFixed(2)}` : (data?.session?.payment_intent?.amount || 'N/A')}</td>
                    </tr>
                    <tr>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem', fontWeight: 700}}>Name:</td>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem'}}>{data?.session?.customer_details?.name || 'N/A'}</td>
                    </tr>
                    <tr>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem', fontWeight: 700}}>Email:</td>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem'}}>{data?.session?.customer_details?.email || 'N/A'}</td>
                    </tr>
                    <tr>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem', fontWeight: 700}}>Date:</td>
                      <td style={{border: '1px solid #ffb3c6', padding: '0.5rem'}}>{new Date().toLocaleString()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p style={{textAlign: 'center', marginTop: '1rem', fontStyle: 'italic'}}>Keep this for your records</p>
              <div style={{display: 'flex', justifyContent: 'center', marginTop: '1rem'}}>
                <button
                  onClick={() => { window.location.href = '/'; }}
                  style={{
                    background: '#ffb3c6',
                    border: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: 6,
                    cursor: 'pointer',
                    fontWeight: 600,
                  }}
                >
                  Back to main page
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Success;
